export const DEPLOYMENT_STATUSES = {
    in_progress: {
        icon: 'fas fa-spinner fa-spin',
        color: 'Warning',
        title: 'In progress',
    },
    completed: {
        icon: 'fas fa-check',
        color: 'Success',
        title: 'Success',
    },
    failed: {
        icon: 'fas fa-exclamation',
        color: 'Error',
        title: 'Fail',
    },
    wait_payment: {
        icon: 'fas fa-shopping-cart',
        color: 'Info',
        title: 'Awaiting payment',
    },
    wait_resume: {
        icon: 'fas fa-stop',
        color: 'Success',
        title: 'Awaiting resume',
    },
    wait_single_payment: {
        icon: 'fas fa-shopping-cart',
        color: 'Info',
        title: 'Payment awaiting',
    },
    paused: {
        icon: 'fas fa-pause',
        color: 'Warning',
        title: 'Stopped',
    },
}